import { useState } from 'react';
import { ViewId } from '~/shared/utils';
import { useIntl } from 'react-intl';
import {
  CaptionButton,
  IconWithCaptionButton,
} from '~/shared/components/ui/Button';
import { GetMessageWithIntl } from '~/shared/components';
import { getGenerallyIconElement } from '~/shared/components/parts/Button/GenerallyIcons';
import { Radio, RadioItem } from '~/shared/components/parts/Radio/Radio';

interface ConfirmationPanelItemProps {
  companyInfo?: string;
  evaluationIndex1?: string;
  evaluationIndex2?: string;
  evaluationIndex3?: string;
  evaluationIndex4?: string;
  isPublic?: boolean;
}

interface ConfirmationPanelFooterProps {
  onBack: () => void;
  onToEdit: () => void;
}

const VIEW_ID: ViewId = 'OCP_PR_INPUT';
export const ConfirmationPanelItem = ({
  companyInfo,
  evaluationIndex1,
  evaluationIndex2,
  evaluationIndex3,
  evaluationIndex4,
  isPublic,
}: ConfirmationPanelItemProps) => {
  const intl = useIntl();
  const radioValues = ['sampleDoc', 'publicInfo'];
  const radioItems: RadioItem[] = [
    {
      displayName: GetMessageWithIntl(intl, {
        id: 'autoGenerateSampleDoc',
        prefixId: VIEW_ID,
      }),
      value: radioValues[0],
    },
    {
      displayName: GetMessageWithIntl(intl, {
        id: 'publicInfo',
        prefixId: VIEW_ID,
      }),
      value: radioValues[1],
    },
  ];
  const [radio, setRadio] = useState(
    isPublic ? radioValues[1] : radioValues[0]
  );
  const [readMore, setReadMore] = useState(false);

  return (
    <>
      <div className="tab-info-body">
        <div className="description-area">
          <p className="title">
            {getGenerallyIconElement('unchecked')}
            現在情報の確認
          </p>
          <p className="text-box">
            <span className="text">
              現在の登録情報を確認します。
              <br />
              初回の場合は、自社企業情報より自動生成したサンプル文章を初期表示します。必ず確認し、編集してください。
              <br />
              画面は他企業が参照する企業紹介ページと同レイアウトになっています。
            </span>
          </p>
          <Radio
            name="radioBtn"
            className="group"
            items={radioItems}
            value={radio}
            onChangeState={setRadio}
            disabled={true}
          />
        </div>
        <div className="expandable-container-area">
          <div className="container-title">企業紹介</div>
          <div
            className={`expandable-container-text ${
              readMore ? 'is-expanded' : ''
            }`}
          >
            {companyInfo}
          </div>
          <IconWithCaptionButton
            name="readMore"
            iconType={readMore ? 'up' : 'down'}
            caption={readMore ? '詳細を閉じる' : 'もっと見る'}
            onClick={() => {
              readMore ? setReadMore(false) : setReadMore(true);
            }}
          />
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">得意な生産形態</div>
            <div className="container-text">{evaluationIndex1}</div>
          </div>
          <div className="description-container">
            <div className="container-title">品質保証・検査</div>
            <div className="container-text">{evaluationIndex2}</div>
          </div>
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">主要取引業界</div>
            <div className="container-text">{evaluationIndex3}</div>
          </div>
          <div className="description-container">
            <div className="container-title">技術・設備のポイント</div>
            <div className="container-text">{evaluationIndex4}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export const ConfirmationPanelFooterItem = ({
  onBack: onBack,
  onToEdit: onToEdit,
}: ConfirmationPanelFooterProps) => {
  const intl = useIntl();
  return (
    <>
      <CaptionButton
        name="resetBtn"
        caption={GetMessageWithIntl(intl, { id: 'return' })}
        className="btn"
        onClick={onBack}
        buttonType="basic"
      />
      <CaptionButton
        name="resetBtn"
        caption={GetMessageWithIntl(intl, { prefixId: VIEW_ID, id: 'toEdit' })}
        className="btn"
        onClick={onToEdit}
        buttonType="basic"
      />
    </>
  );
};
